import { EndpointType } from "./Endpoints";
import { FEATURE, ONPREMISE_MODE_MASK } from "./FeatureFlag";

export const getModelListApiUrl = (
  backendUrl: string,
  endpointType: EndpointType,
): string => {
  return `${backendUrl}/api/${endpointType}`;
};

export const getResultApiUrl = (
  backendUrl: string,
  requestId: string,
): string => {
  return `${backendUrl}/api/result/${requestId}`;
};

export const getAsyncInferenceApiUrl = (
  backendUrl: string,
  endpointType: EndpointType,
): string => {
  return `${backendUrl}/api/${endpointType}/inference`;
};

export const getSyncInferenceApiUrl = (
  backendUrl: string,
  endpointType: EndpointType,
  accessToken: string,
): string => {
  // 온프렘 환경에서는 기존 API 경로 사용
  if (FEATURE & ONPREMISE_MODE_MASK) {
    return `${backendUrl}/api/${endpointType}/sync-inference`;
  }

  // SaaS 환경: 비로그인 - demo, 로그인 - playground
  const basePath = accessToken === "" ? "demo" : "playground";
  let endpointPath = "";

  switch (endpointType) {
    case "extractor":
      endpointPath = "prebuilt-infomation-extract";
      break;
    case "ocr":
      endpointPath = "ocr";
      break;
    case "layout-analysis":
      endpointPath = "document-parse";
      break;
    default:
      throw new Error(`Unsupported endpoint type: ${endpointType}`);
  }

  return `${backendUrl}/v1/web/${basePath}/${endpointPath}/sync-inference`;
};
